/**
 * @start
 * @todo Удалить файл с RS
 * @description Данный функционал появился в задаче CD-93943, будет удалён в задаче CD-97932
 */
import { useApplicationContext } from '../serp/containers/ApplicationContext';

let enabled: boolean | null = null;

/**
 * @description Не требуется тестирование так как RS с файлом в скором времени будут удалены
 */
/* istanbul ignore next */
export function useCoworkingWorkplacePriceEnabledRS(): boolean {
  const { config } = useApplicationContext();

  if (enabled === null) {
    enabled = !!config.get<boolean>('CoworkingWorkplacePrice.Enabled');
  }

  return enabled;
}
